/* THE SIGN — collection.js
   Kolekcja: poziomy pasek filtrów (dropdowny) + auto-submit sortowania.
   - otwarty dropdown zamyka się po kliknięciu poza nim lub Escape,
   - naraz otwarty jest tylko jeden dropdown. */
(function () {
  'use strict';

  var dropdowns = document.querySelectorAll('[data-facet-dropdown]');

  function closeAll(except) {
    dropdowns.forEach(function (d) {
      if (d !== except) d.removeAttribute('open');
    });
  }

  dropdowns.forEach(function (d) {
    d.addEventListener('toggle', function () {
      if (d.open) closeAll(d);
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-facet-dropdown]')) closeAll();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAll();
  });

  /* Sortowanie: submit formularza GET po zmianie selecta. */
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      if (!select.form) return;
      if (select.form.requestSubmit) {
        select.form.requestSubmit();
      } else {
        select.form.submit();
      }
    });
  });

  /* Filtry: checkbox od razu stosuje filtr (pełny GET — panel się zamyka,
     kółko myszy nie zostaje schwytane przez otwarty dropdown). */
  document.querySelectorAll('.facets__values input[type="checkbox"]').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (!form) return;
      if (form.requestSubmit) form.requestSubmit();
      else form.submit();
    });
  });

  /* Linki kategorii/branż w sidebarze przenoszą aktywne filtry
     (parametry filter.*), żeby zmiana kategorii nie gubiła filtrowania. */
  (function preserveFiltersInNav() {
    var params = new URLSearchParams(window.location.search);
    var filtry = [];
    params.forEach(function (value, key) {
      if (key.indexOf('filter.') === 0 && value !== '') filtry.push([key, value]);
    });
    if (!filtry.length) return;
    document.querySelectorAll('.collection-nav__link').forEach(function (link) {
      try {
        var url = new URL(link.href, window.location.origin);
        filtry.forEach(function (kv) {
          if (!url.searchParams.has(kv[0])) url.searchParams.append(kv[0], kv[1]);
        });
        link.href = url.toString();
      } catch (e) { /* ignoruj niepoprawne linki */ }
    });
  })();

  /* Sidebar „Kategorie i branże": na desktopie zawsze rozwinięty
     (details jest elementem mobilnym; CSS ukrywa tam tylko summary). */
  var navToggle = document.querySelector('[data-nav-toggle]');
  if (navToggle) {
    var mqDesktop = window.matchMedia('(min-width: 990px)');
    var syncNavToggle = function () {
      if (mqDesktop.matches) navToggle.setAttribute('open', '');
    };
    syncNavToggle();
    mqDesktop.addEventListener('change', syncNavToggle);
  }
})();
